import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'cadastro',
    loadChildren: () => import('./funcionalidades/formulario-de-cadastro/funcionalidade.module').then(m => m.AppModule)
  },
  {
    path: 'agendamento',
    loadChildren: () => import('./funcionalidades/agendamento-interno/funcionalidade.module').then(m => m.AppModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
